import { render, staticRenderFns } from "./CustomerAgreement1.vue?vue&type=template&id=918f88da&scoped=true&"
import script from "./CustomerAgreement1.vue?vue&type=script&lang=ts&"
export * from "./CustomerAgreement1.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerAgreement1.vue?vue&type=style&index=0&id=918f88da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918f88da",
  null
  
)

export default component.exports